import { render, staticRenderFns } from "./ExpirationDate.vue?vue&type=template&id=213d5a5f&"
import script from "./ExpirationDate.vue?vue&type=script&lang=js&"
export * from "./ExpirationDate.vue?vue&type=script&lang=js&"
import style0 from "./ExpirationDate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports